export default __webpack_public_path__ + "img/d444f3eedd4364601cb598a86808e533.png";